import "./Trending.module.css";
import BrandNavigationHeader from "@/reusable_sections/Header";
import CurrentTopTrends from "./sections/CurrentTopTrends";
import CompanyDirectory from "@/reusable_sections/Footer";
export default function TrendingPage() {
  return <div>
      <BrandNavigationHeader />
      <CurrentTopTrends />
      <CompanyDirectory />
    </div>;
}